import React, { useState } from "react";
import "./Preguntas.css";
import maniqui from "../../assets/img/Preguntas/maniqui.png";
import { PreguntasCardsPoliester } from "./PreguntasCardsPoliester";
import { PreguntasCardsAlgodon } from "./PreguntasCardsAlgodon";
import { TableComponent } from "./TableComponent";

export const Preguntas = () => {
  const items = [
    {
      icon: "A",
      name: "Ancho de hombro: ",
      text: "Tomar la medida desde la unión del cuello hasta el borde del hombro.",
    },
    {
      icon: "B",
      name: "Contorno de pecho: ",
      text: "Comenzando por la axila, rodeá con el centímetro la parte más ancha del tórax.",
    },
    {
      icon: "C",
      name: "Contorno de cintura: ",
      text: "Medí la parte más estrecha de tu cuerpo entre el busto y la cadera.",
    },
    {
      icon: "D",
      name: "Contorno de cadera: ",
      text: "Medí la parte más ancha de tu cadera.",
    },
    {
      icon: "E",
      name: "Largo de cadera: ",
      text: "Medí desde el hombro hasta el largo del brazo.",
    },
    {
      icon: "F",
      name: "Largo de talle: ",
      text: "Medí la distancia desde la unión del cuello con el hombro, hasta la cadera, pasando por el del busto.",
    },
  ];

  const [selected, setSelected] = useState(null);

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }

    setSelected(i);
  };

  return (
    <section id="preguntas">
      <h3 className="preguntas-title">Preguntas frecuentes</h3>
      <div className="preguntas-item" id={1}>
        <div className="preguntas-item-title" onClick={() => toggle(1)}>
          <span>{selected === 1 ? "-" : "+"}</span>
          <h2>¿Cuál es mi talle?</h2>
        </div>
        <div
          className={
            selected === 1
              ? "preguntas-item-content show"
              : "preguntas-item-content"
          }
        >
          <div className="preguntas-item-content-1">
            <section className="preguntas-item-content-text">
              <div className="preguntas-item-content-subtitle">
                <p>
                  Para saberlo, primero tenés que tomarte las siguientes medidas
                  (para los contornos, siempre tratá que el centímetro se
                  mantenga en posición horizontal)
                </p>
              </div>
              <div className="preguntas-item-container">
                {items.map((item) => (
                  <div
                    key={item.icon}
                    className="preguntas-item-content-text--item"
                  >
                    <div className="preguntas-item-content-text--item-icon">
                      <span>{item.icon}</span>
                    </div>
                    <span className="preguntas-item-content-text--item-name">
                      <b>{item.name}</b>
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>
              <div className="preguntas-item-content-subtitle">
                <p>
                  Una vez que hayas tomado tus medidas, buscá en la tabla de
                  talles cuál es el que mejor se ajusta a las mismas. Si estás
                  en el límite entre dos talles, te recomendamos elegir el más
                  grande.
                </p>
              </div>
            </section>
            <section className="preguntas-item-content-image">
              <img src={maniqui} alt="maniqui de muestra de talles" />
            </section>
            <TableComponent />
          </div>
        </div>
      </div>
      <div className="preguntas-item" id={2}>
        <div className="preguntas-item-title" onClick={() => toggle(2)}>
          <span>{selected === 2 ? "-" : "+"}</span>
          <h2>¿Cómo cuidar mis prendas?</h2>
        </div>
        <div
          className={
            selected === 2
              ? "preguntas-item-content show"
              : "preguntas-item-content"
          }
        >
          <div className="preguntas-item-content-2">
            <section className="preguntas-item-content-subtitle">
              <p>
                Los siguientes consejos te permitirán disfrutar de tus prendas
                Verdivia por mucho tiempo con la calidad del primer día.
              </p>
            </section>
            <section className="preguntas-item-content-card">
              <div className="preguntas-item-content-card--left">
                <p className="preguntas-item-content-card--title">
                  Prendas de poliéster
                </p>
                <PreguntasCardsPoliester />
              </div>
              <div className="preguntas-item-content-card--right">
                <p className="preguntas-item-content-card--title">
                  Prendas de algodón
                </p>
                <PreguntasCardsAlgodon />
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};
